import axios from 'axios'
import router from '@/router'

/**
 * Create the axios instance
 */
const instance = axios.create({
  responseType: 'json'
})

instance.defaults.baseURL = process.env.VUE_APP_API_BASE
instance.defaults.headers.get['Accepts'] = 'application/json'

/**
 * Intercept every request and ... at this moment, nothing.
 */
instance.interceptors.request.use(request => {
  if (sessionStorage.getItem('token')) {
    request.headers.common['Authorization'] =
      'Basic ' + sessionStorage.getItem('token')
  }
  // console.log('AXIOS.Request:', request)
  return request
})

/**
 * Intercept every response and on error, interrogate status and
 * redirect to appropriate error page.
 */
instance.interceptors.response.use(
  response => {
    // console.log('AXIOS.response:', response)
    return response
  },
  function(error) {
    // console.log('AXIOS.error:', error)
    // Let known errors fall to the error pages
    // let knownErrors = [400, 401, 403, 500]
    let knownErrors = [400, 401, 403]
    if (knownErrors.includes(error.response.status)) {
      router.push({ name: error.response.status })
    }
    // else return to aclling page to manage
    return Promise.reject(error)
  }
)

export default instance
